import { gql } from "@apollo/client";export default gql`mutation DeleteCollectionTagMap($ids: [Int!]) {
  delete_collection_tag_map(where: {id: {_in: $ids}}) {
    affected_rows
  }
}
`;
